import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];
let galleryArticles = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  galleryArticles = importAll(
    (require as any).context("./gallery-articles", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 1.5 },
          { index: 3, aspectRatio: 1.5 },
          { index: 7, aspectRatio: 1.5 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/Yl3aeXnMGwM"}
      />

      <ReplicaBigTitle title="Quidditch World Cup Cancelled!" />
      <ReplicaParagraph>
        Judging by the front cover headings, this issue must have been published
        sometime after the events of Order of the Phoenix and before The
        Quibbler fell under Ministry control (which, by that point, meant Death
        Eater control). The main focus — the cancellation of the Quidditch World
        Cup, which was scheduled for the summer of 1998 — leads me to believe
        that this issue likely came out during the first half of Deathly
        Hallows. In any case, the timeline of events suggests that it should
        include reports related to the ongoing war against You-Know-Who, who had
        by then been publicly confirmed to have returned, as well as stories
        concerning the rise in dark magic activity.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryArticles)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
